<div class="modal-header">
  <h4 class="modal-title">Finish Application by Phone</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.close()"
  ></button>
</div>
<div class="modal-body">
  <p>Thank you! A loan officer will call you soon.</p>
  <p>
    We usually respond within 24 hours, but you may also call this branch during
    normal business hours.
  </p>

  <div class="row">
    <div class="col">
      <div class="card bg-light mb-4">
        <div class="card-body">
          <app-branch-info></app-branch-info>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3">
    <label class="form-label" for="confirmPhoneNumber">
      Confirm Phone Number
      <span class="color-error">*</span>
    </label>
    <input
      [ngClass]="['form-control', !isPhoneValid ? 'phone-invalid' : '']"
      id="confirmPhoneNumber"
      placeholder="Phone number"
      type="text"
      aria-label="Confirm phone number"
      [(ngModel)]="phone"
      required
      (change)="onPhoneChange($event)"
    />
  </div>
</div>
<div class="modal-footer">
  <button
    [disabled]="isSaving"
    type="button"
    class="btn btn-secondary no-expand"
    (click)="onCancel()"
  >
    Cancel
  </button>
  <button
    [disabled]="!validate(phone) || !phone || isSaving"
    type="button"
    class="btn btn-primary no-expand"
    (click)="onConfirm()"
  >
    <span
      *ngIf="isSaving"
      class="spinner-border spinner-border-sm me-2"
      role="status"
      aria-hidden="true"
    ></span>
    <span>Confirm</span>
  </button>
</div>
